import React from 'react';
import { useDispatch } from 'react-redux';
import DTCopyTextSendMacroView from '../DTCopyTextSendMacroView';
import { shopifyReplaceOrderWithCoupon } from '../../../../../actions/tools/ShopifyActions';
import { withConfirmation } from '../../../DTConfirmationView/withConfirmation';

const DTReplaceOrderWithCouponThenSendMacroNode = () => {
  const dispatch = useDispatch();

  const handleNextButtonClick = async () => await dispatch(shopifyReplaceOrderWithCoupon());

  return (
    <DTCopyTextSendMacroView
      buttonText={'REPLACE'}
      onNextButtonClick={handleNextButtonClick}
      hideCopyText={true}
      popupConfirmationText={"You are about to replace the customer's items and copy the response to the text box"}
      customErrorMessage={'There was a problem processing your replacement request.'}
    />
  );
};

export default withConfirmation(DTReplaceOrderWithCouponThenSendMacroNode);
